module.exports = __webpack_public_path__ + "assets/img/8a7829bb32e461906a72119e4285ac38.svg";